let simulatedWorkRole: string | undefined;

export function setSimulatedWorkRole(role: string | undefined) {
  simulatedWorkRole = role;
}

export function getSimulatedWorkRole() {
  return simulatedWorkRole;
}
